import { Tab, Tabs, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { navItems } from './customers-page-side-nav-items';

export const CustomersSideNav: React.FC = () => {
  const navigate = useNavigate();
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const location = useLocation();
  const { customerId } = useParams();
  const theme = useTheme();

  useEffect(() => {
    const pathSegments = location.pathname.split('/');

    const currentIndex = navItems.findIndex((item) => pathSegments.includes(item.path));

    setSelectedIndex(currentIndex !== -1 ? currentIndex : 0);
  }, [location.pathname]);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setSelectedIndex(newValue);
    navigate(navItems[newValue].path);
  };

  /**
   * When the user is on a nested detail page (e.g. a single contract), clicking that
   * tab returns them to its list page — same as the back button.
   */
  const handleTabClick = (index: number) => {
    if (index !== selectedIndex) return;

    const { path } = navItems[index];
    const pathSegments = location.pathname.split('/');
    const isOnNestedDetail = Boolean(pathSegments[pathSegments.indexOf(path) + 1]);

    if (isOnNestedDetail) {
      navigate(`/customers/${customerId}/${path}`);
    }
  };

  return (
    <Tabs
      value={selectedIndex}
      onChange={handleTabChange}
      sx={{
        borderBottom: `1px solid ${theme.palette.divider}`,
        minHeight: 'unset',
      }}
    >
      {navItems.map((item, index) => (
        <Tab
          key={item.label}
          label={item.label}
          onClick={() => handleTabClick(index)}
          sx={{ textTransform: 'none', fontSize: 14, minHeight: 'unset' }}
        />
      ))}
    </Tabs>
  );
};
